// Text files
import iliad from './iliad.md'
import onWar from './on-war.md'

// Images
import rovaniemi1944 from './rovaniemi-1944.jpg'

// TODO: dynamic imports

export default {

  // Text files
  iliad: {
    type: 'txt',
    size: 1034893,
    name: 'iliad-homer-books-i-thru-xxiv',
    data: iliad
  },

  onWar: {
    type: 'txt',
    size: 401893,
    name: 'on-war-general-von-clausewitz',
    data: onWar
  },

  // Images
  rovaniemi1944: {
    type: 'jpg',
    size: 1901893,
    name: 'langemann-bole',
    data: rovaniemi1944
  }

}
